export const changeLoginAbility = ([value], state, { changeValue }) => {
  changeValue(state, 'login_ability', () => value);
};

export const toggleGdpr = ([required], state, { changeValue }) => {
  changeValue(state, 'showGdpr', () => required);

  if (!required) {
    changeValue(state, 'policy_agree', () => false);
    changeValue(state, 'marketing_agree', () => false);
  }
};

export const setLogin = ([email], state, { changeValue }) => {
  if (email) {
    changeValue(state, 'login', () => email);
  }
};

export const removeLogin = (args, state, { changeValue }) => {
  changeValue(state, 'login', () => '');
};

/**
 * XXX mutates formState
 * @param {Array} args
 * @param {MutableState} state
 * @param {Tools} tools
 */
export const clearSubmitError = (args, state) => {
  state.formState.submitError = undefined;
  state.formState.submitErrors = undefined;
};

export const setUserRole = ([user_role], state, { changeValue }) => {
  changeValue(state, 'user_role', () => user_role);
};
